function assertBrightnessValue(value, verb) {
  if (typeof value !== "number" || !Number.isFinite(value) || value < 0 || value > 1) {
    throw new Error(`${verb}: value must be a number between 0 and 1`);
  }
}
var SYSTEM_MODES = [
  "manual",
  "automatic"
];
function assertSystemMode(mode) {
  if (mode !== "manual" && mode !== "automatic") {
    throw new Error(`Brightness.setSystemMode: mode must be one of: ${SYSTEM_MODES.join(", ")}.`);
  }
}
function assertBrightnessListener(listener) {
  if (typeof listener !== "function") {
    throw new Error("Brightness.addListener: listener must be a function");
  }
}
export {
  assertBrightnessListener,
  assertBrightnessValue,
  assertSystemMode
};
//# sourceMappingURL=validate.js.map
